/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileTxt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M10.32 17v-3.986H8.88v-.885h3.926v.885h-1.44V17zm2.77 0 1.5-2.526-1.426-2.345h1.199l1.005 1.682.978-1.682h1.152l-1.433 2.365L17.572 17h-1.2l-1.085-1.843L14.242 17zm6.2 0v-3.986h-1.44v-.885h3.927v.885h-1.44V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileTxt as FileTxt };
